import type { Config } from 'tailwindcss';

const config = {
  relative: true,
  darkMode: ['class'],
  content: ['./pages/**/*.{ts,tsx}', './components/**/*.{ts,tsx}', './app/**/*.{ts,tsx}', './src/**/*.{ts,tsx}'],
  prefix: '',
  theme: {
    container: {
      center: true,
      padding: '2rem',
      screens: {
        '2xl': '1400px',
      },
    },
    extend: {
      animation: {
        'accordion-down': 'accordion-down 0.2s ease-out',
        'accordion-up': 'accordion-up 0.2s ease-out',
      },
      colors: {
        primary: '#fff',
        'primary-foreground': '#0c3d4a',
        secondary: '#0c3d4a',
        'secondary-foreground': '#fff',
        accent: '#d1ac00',
      },
      keyframes: {
        'accordion-down': {
          from: { height: '0' },
          to: { height: 'var(--radix-accordion-content-height)' },
        },
        'accordion-up': {
          from: { height: 'var(--radix-accordion-content-height)' },
          to: { height: '0' },
        },
      },
      margin: {
        block: '100px',
      },
      padding: {
        block: '100px',
      },
      maxWidth: {
        padded: 'calc(100% - 2rem)',
        viewport: '1200px',
      },
    },
    fontFamily: {
      sans: ['Chivo', 'sans-serif'],
      mono: ['Chivo Mono', 'monospace'],
      righteous: ['Righteous', 'cursive'],
    },
    // 640, 768, 1024, 12800, 1536
    screens: {
      sm: '600px',
      md: '800px',
      lg: '900px',
      xl: '1000px',
      '2xl': '1200px',
    },
  },
  plugins: [require('tailwindcss-animate')],
} satisfies Config;

export default config;
